module.exports = __webpack_public_path__ + "img/IS.f2597376.svg";